module.exports = __webpack_public_path__ + "static/img/zdh-app.8a26f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202403/zdh-app.png
// module id = dU9D
// module chunks = 0